module.exports = __webpack_public_path__ + "img/female-child-foot.00911c5f.svg";